/* ตารางการ์ดเมนู — การ์ดขนาดคงที่ เรียงกึ่งกลางจอ (รูปแบบอยู่ใน main.css) */
export default function TileGrid({ children }) {
  return <div className="tile-grid">{children}</div>;
}
